import { useEffect, useRef } from "react";

const AdSenseAd = ({ slot, format }) => {
  const adRef = useRef(null);
  const adLoaded = useRef(false);

  useEffect(() => {
    const tryPushAd = () => {
      if (!adRef.current) return;
      const width = adRef.current.offsetWidth;
      if (width === 0) {
        setTimeout(tryPushAd, 300);
        return;
      }
      try {
        if (!adLoaded.current && window.adsbygoogle) {
          (window.adsbygoogle = window.adsbygoogle || []).push({});
          adLoaded.current = true;
        }
      } catch (err) {
        console.error("AdSense error:", err);
        if (!err.message.includes("already have ads")) {
          setTimeout(tryPushAd, 500);
        }
      }
    };
    tryPushAd();
  }, [slot]);

  return (
    <div style={{ width: "100%", minHeight: "250px" }}>
      <ins
        className="adsbygoogle"
        data-ad-client="ca-pub-1915488793968759"
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive="true"
        ref={adRef}
      ></ins>
    </div>
  );
};

export default AdSenseAd;